import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { roleHome, useAuth } from '@/context/AuthContext'
import { tokenStore } from '@/lib/api'
import { isStandalone } from '@/lib/push'
import LogoLoader from '@/components/ui/LogoLoader'

// Only the first route of a page load is a launch. Module scope, so in-app
// navigation back to "/" (the console's "MPG marketplace" logo) is never redirected.
let decided = false

/**
 * The installed app always opens on "/", the marketplace. A signed-in team
 * member is sent on to their console instead; customers, signed-out visitors
 * and ordinary browser tabs are left alone.
 *
 * The manifest start_url stays "/" on purpose: iOS freezes the start URL when
 * the app is added to the Home Screen, so changing it would only reach phones
 * that reinstall. Deciding here fixes every existing install.
 */
export default function LaunchRedirect() {
  const { user, loading } = useAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  // Only worth holding the screen when there is a stored session to resolve.
  const [pending, setPending] = useState(
    () => !decided && pathname === '/' && isStandalone() && !!tokenStore.get(),
  )

  useEffect(() => {
    if (loading || decided) return
    decided = true
    if (pending && user && user.role !== 'customer') {
      // navigate() runs as a transition, so the splash is left up until the
      // console route has rendered; clearing it here would flash the
      // marketplace for a frame first.
      navigate(roleHome(user), { replace: true })
    } else {
      setPending(false)
    }
  }, [loading, pending, user, navigate])

  useEffect(() => {
    if (pathname !== '/') setPending(false)
  }, [pathname])

  if (!pending || pathname !== '/') return null

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-primary bg-noise">
      <LogoLoader tone="dark" />
    </div>
  )
}
